import { PaginationInput } from '../common/paginationInput';
import { UserFilter } from './userFilter';

export class UserInput {
  paginationInput: PaginationInput;
  filter: UserFilter;
  isPlanDay: boolean;

  constructor(paginationInput: PaginationInput, filter: UserFilter, isPlanDay?: boolean) {
    this.paginationInput = paginationInput;
    this.filter = filter;
    this.isPlanDay = isPlanDay;
  }
}
